import omit from 'lodash/omit';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import set from 'lodash/fp/set';
import cloneDeep from 'lodash/cloneDeep';

import A from './types';
import create from '~/misc/create';

const initialState = {
  byName: {},
};

const actionsToDispatch = (oldValue, noNeedies, need) => {
  if (oldValue === noNeedies) {
    // no changes - nothing to do;
    return null;
  }

  if (noNeedies) {
    // resource not needed anymore
    return [create(A.RESOURCE_DISPOSED, need)];
  }

  // resource has first needy, so it request should be send
  return [create(A.RESOURCE_REQUESTED, need)];
};

const checkNeed = (state, {name, need, needy}, toAdd) => {
  const subState = state.byName[name] || {};
  const {needies, ...resource} = subState[need.key] || {
    identity: need,
    needies: {},
    emptyNeedies: true,
  };

  const newNeedies = toAdd
    ? {...needies, [needy.key]: needy}
    : omit(needies, needy.key);

  const newResource = {
    ...resource,
    needies: newNeedies,
    emptyNeedies: isEmpty(newNeedies),
  };

  const shouldBeRemoved = newResource.emptyNeedies;

  const index = shouldBeRemoved
    ? omit(subState, need.key)
    : {
      ...subState,
      [need.key]: newResource,
    };

  return {
    ...state,
    byName: {
      ...state.byName,
      [name]: index,
    },
    actionsQueue: actionsToDispatch(resource.emptyNeedies, newResource.emptyNeedies, need),
  };
};

const resourceLoad = ({payload, error, pending}, resource) => {
  if (error) {
    return {
      ...resource,
      completed: true,
      error: payload,
      loading: false,
    };
  }

  if (pending) {
    return {
      ...resource,
      loading: true,
    };
  }

  if (payload) {
    return {
      ...resource,
      completed: true,
      loading: false,
      error: null,
      item: {
        ...payload,
        // patching every resource to have identity
        'identity': resource.identity,
        'identity-data': payload.identity,
      },
    };
  }
  return null;
};

const reducer = (state, action) => {
  switch (action.type) {
    case A.RESOURCE_NEEDED: {
      return checkNeed(state, action.payload, true);
    }
    case A.RESOURCE_NOT_NEEDED: {
      return checkNeed(state, action.payload, false);
    }
    case A.RESOURCE: {
      const {key, name} = action.meta;

      const resource = get(state, ['byName', name, key]);
      if (!resource) {
        return null;
      }

      const newResource = resourceLoad(action, resource);

      const needies = Object.keys(newResource.needies).map(needyKey => ({
        need: newResource.identity,
        needy: newResource.needies[needyKey],
      }));

      return {
        ...set(['byName', name, key], newResource, state),
        actionsQueue: needies.map(item => create(A.RESOURCE_UPDATED_DEP, item)),
      };
    }
    case A.RESOURCE_SAVE_BROKER: {
      const obj = action.payload;
      let byName = cloneDeep(state.byName);
      let item = byName[obj.name][obj.key].item;
      let shipments = cloneDeep(item.shipments);
      for (let i = 0; i < shipments.length; i++) {
        if (shipments[i].broker_id === obj.id || shipments[i].company === obj.company) {
          shipments[i].checkedBroker = true;
        }
      }
      item.shipments = shipments;
      return {
        ...state,
        byName,
      };
    }
    case A.RESOURCE_REMOVE_BROKER: {
      const obj = action.payload;
      let byName = cloneDeep(state.byName);
      let item = byName[obj.name][obj.key].item;
      let shipments = cloneDeep(item.shipments);
      for (let i = 0; i < shipments.length; i++) {
        if (shipments[i].broker_id === obj.id || shipments[i].company === obj.company) {
          shipments[i].checkedBroker = false;
        }
      }
      item.shipments = shipments;
      return {
        ...state,
        byName,
      };
    }
    case A.RESOURCE_LOAD_SAVE_BROKER: {
      const obj = action.payload;
      let byName = cloneDeep(state.byName);
      let item = byName[obj.name][obj.key].item;
      item.checkedBroker = true;
      return {
        ...state,
        byName,
      };
    }
    case A.RESOURCE_LOAD_REMOVE_BROKER: {
      const obj = action.payload;
      let byName = cloneDeep(state.byName);
      let item = byName[obj.name][obj.key].item;
      item.checkedBroker = false;
      return {
        ...state,
        byName,
      };
    }
  }

  return null;
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/resources/reducer.js